import React, { useState } from 'react';
import { useStyletron } from 'baseui';
import { DataList, CustomModal } from 'commons-ui';

import { LIST_ENTITY_NAMES } from 'constant';
import { columnConfigs } from './listConfig';
import useService from './useService';
import UserSupportCall from './userSupportCall';
import useUserProfileActions from '../useUserProfileActions';
import { makeActionHandler, makeActionList } from './actions';

const PreviousTickets: React.FC<{}> = () => {
	const [forceUpdate, setForceUpdate] = useState<boolean>(false);
	const { getPreviousTicketsData, createTicket } = useService(setForceUpdate);
	const [css] = useStyletron();
	const { getActionHandler, getActionList } = useUserProfileActions(makeActionHandler, makeActionList, {
		handleForceUpdate: setForceUpdate,
		forceUpdate,
		createTicket
	});
	const actions = getActionList();
	return (
		<div>
			<div
				className={css({
					height: '60px',
					display: 'flex',
					alignItems: 'center',
					backgroundColor: 'white',
					paddingLeft: '10px',
					paddingRight: '20px',
					borderTop: '1px solid rgb(242, 242, 242)',
					justifyContent: 'space-between',
					width: '100vw'
				})}>
				<UserSupportCall />
			</div>
			<DataList
				fetchData={getPreviousTicketsData}
				getActionHandler={getActionHandler}
				actions={actions}
				columnConfigs={columnConfigs}
				rowHeight={50}
				entity={LIST_ENTITY_NAMES.PREVIOUSTICKETS}
				height='calc(100vh - 220px)'
				globalForceUpdate={forceUpdate}
			/>
			<CustomModal />
		</div>
	);
};

export default PreviousTickets;
